export default __webpack_public_path__ + "static/media/charts.b0cf16ed.png";